module.exports = __webpack_public_path__ + "static/media/julesMapLetter.e244db9d.png";